// document.addEventListener("DOMContentLoaded",initializeDataTables);
// document.addEventListener("DOMContentLoaded", initializeDataTables);
document.addEventListener("turbo:load", initializeDataTables);

function initializeDataTables() {
  console.log("Load: datatables/initialize_tables.js");

  // Set safe global defaults for all DataTables
  $.extend(true, $.fn.dataTable.defaults, {
    deferRender: true,
    pageLength: 25,
    responsive: true,
    autoWidth: false,
    stateSave: true,         // remembers sorting/searching
    scrollCollapse: true     // prevents empty whitespace on short tables
  });

  // Utility function to safely initialize a DataTable
  function initDataTable(selector, options = {}) {
    const el = document.querySelector(selector);
    if (el && !$.fn.DataTable.isDataTable(el)) {
      const rowCount = el.querySelectorAll("tbody tr").length;
      const largeTable = rowCount > 1000; // threshold for scroller mode

      $(el).DataTable({
        // universal options
        ...options,
        // conditionally enable Scroller for large tables
        ...(largeTable && {
          scrollY: "70vh",
          scroller: true
        })
      });
    }
  }

  initDataTable("#unlinked_orgs_table", { order: [[0, "asc"]] });
  initDataTable("#list_orgs", { order: [[0, "asc"]] });
  initDataTable("#changes_table", { order: [[0, "asc"]] });
  initDataTable("#challenges_list", { order: [[3, "asc"]] });
  initDataTable("#coupons_list", { order: [[0, "asc"]] });
  initDataTable("#stretchpools_list", { order: [[2, "desc"]] });
  initDataTable("#admins_list", { order: [[0, "asc"]] });
  initDataTable("#matches_list", { order: [[3, "asc"]] });
  initDataTable("#qualifying_donations_list");
  initDataTable("#donations_list", { order: [[0, "desc"]] });
  initDataTable("#list_users", { order: [[1, "asc"]] });
  initDataTable("#event_orgs", { order: [[0, "asc"]] });
  initDataTable("#event_fundraisers", { order: [[0, "asc"]] });
  initDataTable("#event_interests", { order: [[0, "asc"]] });
}